import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { Tag } from '@/ts/interfaces/tags'
import { RootState } from '../index'

interface TagsState {
  tags: Tag[]
}

const initialState: TagsState = {
  tags: []
}

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    setTags: (state, action: PayloadAction<Tag[]>) => {
      state.tags = action.payload
    },
    addTag: (state, action: PayloadAction<Tag>) => {
      state.tags.push(action.payload)
    },
    updateTag: (state, action: PayloadAction<Tag>) => {
      const index = state.tags.findIndex((p) => p.id === action.payload.id)
      if (index !== -1) {
        state.tags[index] = action.payload
      }
    },
    deleteTag: (state, action: PayloadAction<number>) => {
      const index = state.tags.findIndex((p) => p.id === action.payload)
      if (index !== -1) {
        state.tags[index].deleted_at = new Date()
      }
    },
    clearTags: (state) => {
      state.tags = []
    }
  }
})

export const { setTags, addTag, updateTag, deleteTag, clearTags } = tagsSlice.actions

export const selectTags = (state: RootState) => state.tags.tags
export const selectActiveTags = createSelector([selectTags], (tags) => tags.filter((p) => !p.deleted_at))

export default tagsSlice.reducer
